let tagsObject = []
function updateSearchresult(params) {
     document.querySelector('.data_search_filters').innerHTML = ''
     if(tagsObject.length){
      tagsObject.map((item)=>{
        let htmldiv = `<div class="Search_result" text='${item}'><span>${item}</span><button type="button" ><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 256 256" data-sentry-element="X" data-sentry-source-file="ActiveFilter.tsx"><path d="M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z"></path></svg></button></div>`
        document.querySelector('.data_search_filters').insertAdjacentHTML('beforeend', htmldiv);
      }) 
     }      
      if (tagsObject.length > 0) {
      let clearButton = `<div class="clear-filters appended_clear">Clear All</div>`;
      document.querySelector('.data_search_filters').insertAdjacentHTML('beforeend', clearButton);
      }
      document.querySelectorAll('.data_search_filters button').forEach((item) => {
      item.addEventListener('click', function() {
        let tagss = this.parentNode.getAttribute('text')
        document.querySelectorAll(`button.filter-button[data-filter-value="${tagss}"]`).forEach((newss) => {
          newss.classList.remove('active');
        });
        tagsObject = tagsObject.filter(tag => tag !== tagss);
        this.parentElement.remove(); 
        search_filters(); 
        if (tagsObject.length === 0) {
        document.querySelector('.appended_clear').remove()
        }      
      });
      });
}
function search_filters(params) {
    document.querySelectorAll('.collection-matrix__wrapper .product__thumbnail').forEach((item) => {
            let data = item.getAttribute('data-tags') || '';  
            let newdataarray = data.split(',').map(tag => tag.trim());
            if(tagsObject.length === 0){
                item.style.display = 'block'
                return
            }
            if (tagsObject.some(tag=>newdataarray.includes(tag))) {
                item.style.display = 'block'
            } else {
                item.style.display = 'none'
            }
        });
}
document.querySelectorAll('.custom_collection_filters .filter-button').forEach((main) => {
    main.addEventListener('click', function(e) {
        e.preventDefault();        
        let text = this.getAttribute('data-filter-value')
        if (tagsObject.includes(text)) {
            tagsObject = tagsObject.filter(tag => tag !== text);
            document.querySelectorAll(`[data-filter-value="${text}"]`).forEach(btn => btn.classList.remove('active'));
        } else {
            tagsObject.push(text);
            document.querySelectorAll(`[data-filter-value="${text}"]`).forEach(btn => btn.classList.add('active'));
        }       
        search_filters()
        updateSearchresult()
        $('.clear-filters').click(function (e) {
        e.preventDefault();        
        tagsObject= []
        updateSearchresult()
        document.querySelectorAll(`button.filter-button[data-filter-value]`).forEach((newss) => {
            newss.classList.remove('active');
        });
        search_filters()
        })
    });
});

$('button#apply-filters').click(function (e) {
    e.preventDefault();        
    $(this).parents('.filter-drawer').removeClass('open')
})

